import Http from './axios-config';

class StaffActionsService {
    constructor() {
        this.http = new Http();
    }

    /**
     * One page of the staff log, newest first: { data: [{ id, createdAt, action, actor: { id, name, role },
     * target: { type, id, name }, changes: [{ field, from, to }] }], pagination: { totalCount } }.
     * Super admins only (403 for anyone else). A failure shows the usual error toast.
     *
     * @param {{limit: number, offset: number, action?: string, actorRole?: number}} params  actorRole: 1, 3
     *     or 4 - only changes made in that role
     */
    async getStaffActions(params) {
        return await this.http.get('/admins/staff-actions', { params });
    }
}

export default new StaffActionsService();
